import { render, staticRenderFns } from "./BanniereHorizontaleEvenement.vue?vue&type=template&id=24dc8c46&lang=html&"
import script from "./BanniereHorizontaleEvenement.vue?vue&type=script&lang=js&"
export * from "./BanniereHorizontaleEvenement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports